// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"210":"bbfa891f","784":"8a63d597"}[chunkId] + ".chunk.js";
};